import React, { Suspense } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import "./App.css";
import { useState, useEffect } from "react";
import useIdle from "./Hooks/useidle";
import { ToastContainer, toast } from "react-toastify";
import Header from "./Components/Common/Header/header";
import Sidebar from "./Components/Common/Sidebar/sidebar";
import LoginForm from "./Components/Pages/Login/login";
import CountryMaster from "./Components/Pages/CountryMaster/countryMaster";
import StateMaster from "./Components/Pages/StateMaster/stateMaster";
import CityMaster from "./Components/Pages/CityMaster/cityMaster";
// import CitystructureLevel from "./Components/Pages/CitystructureLevel/citystructureLevel";
import OrganizationZone from "./Components/Pages/OrganizationZone/organizationZone";
import OrganizationCircle from "./Components/Pages/OrganizationCircle/organizationCircle";
import OrganizationWard from "./Components/Pages/OrganizationWard/organizationWard";
// import OperationMaster from "./Components/Pages/OperationMaster/operationMaster";
import Vehicle from "./Components/Pages/AssetVehicle/vehicle";
import VehicleV1 from "./Components/Pages/AssetVehicle/vehicleV1";
import RoleCreation from "./Components/Pages/RoleCreation/roleCreation";
import UserCreation from "./Components/Pages/UserCreation/userCreation";
import DriverCreation from "./Components/Pages/DriverCreation/driverCreation";
import LoadingEquipment from "./Components/Pages/LoadingEquipment/loadingEquipment";
import ShiftMaster from "./Components/Pages/ShiftMaster/shiftMaster";
import GvpMaster from "./Components/Pages/GvpMaster/gvpMaster";
import RouteMaster from "./Components/Pages/RouteMaster/routeMaster";
import TransferStationMaster from "./Components/Pages/TransferStationMaster/transferStationMaster";
import ContainerMaster from "./Components/Pages/ContainerMaster/containerMaster";
import DeploymentLocationMaster from "./Components/Pages/DeploymentLocationMaster/deploymentLocationMaster";
//import DeploymentChargeMaster from "./Components/Pages/DeploymentChargeMaster/deploymentChargeMaster";
import NotFound from "./Components/Common/NotFound/NotFound";
import VehicleType from "./Components/Pages/VehicleType/vehicleType";
import ContainerType from "./Components/Pages/ContainerType/containerType";
import CollectionType from "./Components/Pages/CollectionType/collectionType";
import OwnerType from "./Components/Pages/OwnerType/ownerType";
import Company from "./Components/Pages/Company/company";
import { PrivateRoute } from "./Components/Common/PrivateRoute/privateRoute";
import SCVReports from "./Components/Pages/Reports/ScvReports/scvReports";
import SCVDriverMasterReports from "./Components/Pages/Reports/ScvReports/scvDriverMasterData";
import SCVLiveLocation from "./Components/Pages/Reports/ScvReports/scvOverallTrips";
import SCVMasterData from "./Components/Pages/Reports/ScvReports/scvMasterData";
import GVPNotClearence from "./Components/Pages/GvpNotClearence/gvpNotClearence";
import RouteTracking from "./Components/Pages/RouteTracking/routeTracking";
// import GVPRoutePlaning from "./Components/Pages/RoutePlanning/routePlanning";
import ViewVehicleDetails from "./Components/Pages/AssetVehicle/viewVehicleDetails";
import ViewShiftDetails from "./Components/Pages/ShiftMaster/viewShiftDetails";
import ViewCollectionPointsDetails from "./Components/Pages/GvpMaster/viewCollectionPoints";
import ViewDriverDetails from "./Components/Pages/DriverCreation/viewDriverDetails";
import ViewVehicleTypeDetails from "./Components/Pages/VehicleType/viewVehicleTypeDetails";
import PrimaryDeploymentChargeMaster from "./Components/Pages/PrimaryDeploymentChargeMaster/primaryDeploymentChargeMaster";
import SecondaryDeploymentChargeMaster from "./Components/Pages/SecondaryDeploymentChargeMaster/secondaryDeploymentcharge";
import DeploymentLocationDetails from "./Components/Pages/DeploymentLocationMaster/deploymentLocationDetails";
import ContainerDetails from "./Components/Pages/ContainerMaster/containerDetails";
import TransferStationDetails from "./Components/Pages/TransferStationMaster/transferStationDetails";
import WardDetails from "./Components/Pages/OrganizationWard/wardDetails";
import CircleDetails from "./Components/Pages/OrganizationCircle/circleDetails";
import ZoneDetails from "./Components/Pages/OrganizationZone/zoneDetails";
import VehicleTypeDetails from "./Components/Pages/VehicleType/vehicleTypeDetails";
import OwnerTypeDetails from "./Components/Pages/OwnerType/OwnerTypeDetails";
import RouteDetails from "./Components/Pages/RouteMaster/routeDetails";
import CityDetails from "./Components/Pages/CityMaster/cityDetails";
import CompanyDetails from "./Components/Pages/Company/companyDetails";
// import AutoLogout from "./Components/Pages/AutoLogout/logout";
import TripTonnage from "./Components/Pages/Reports/TTRreports/Trip&TonnageReport/tripTonnage";
import ContainerReport from "./Components/Pages/Reports/TTRreports/ContainerReport/containerReport";
import IdleTimeoutModal from "./Hooks/idelTimeout";
import TransferStationDashboard from "./Components/Pages/Reports/TransactionReports/transferStationDetail";
import TSSCTPForTT from "./Components/Pages/Reports/TTRreports/Trip&TonnageReport/TSSCTPForTT";
import TSSCTPForULB from "./Components/Pages/Reports/TTRreports/Trip&TonnageReport/TSSCTPForULB";
import Test from "./Components/Pages/Reports/TTRreports/HookLoaderReport/Vehiclehook";
import Vehiclehook from "./Components/Pages/Reports/TTRreports/HookLoaderReport/Vehiclehook";
import DetailedReport from "./Components/Pages/Reports/SATReports/DetailedReport";
import ReportAtWard from "./Components/Pages/Reports/SATReports/ReportAtWard";
import VehicleMasterSATReport from "./Components/Pages/Reports/SATReports/VehicleMasterSATReport";
import TSSCTPWise from "./Components/Pages/Reports/SATReports/TSSCTPWise";
import Deviation from "./Components/Pages/Reports/SATReports/Deviation";
import TripTSSCTP from "./Components/Pages/Reports/SATReports/SATTripToTSSCTP/TripTSSCTP";
import CircleReport from "./Components/Pages/Reports/ScvReports/CircleReport";
import RouteTrackReport from "./Components/Pages/Reports/ScvReports/RouteTrackReport";
import GVPDayClearence from "./Components/Pages/Reports/GvpReports/gvpDayClearence";
import GVPMultipleClearence from "./Components/Pages/Reports/GvpReports/gvpMultipleClearence";
import transferStationMaster from "./Components/Pages/TransferStationMaster/transferStationMaster";
import TSSCTPView from "./Components/Pages/Reports/TSSCTPView";
import vehicleCapacity from "./Components/Pages/VehicleCapacity/vehicleCapacity";
import containerCapacity from "./Components/Pages/ContainerCapacity/containerCapacity";
// import HookLoader from "../src/Components/Pages/Reports/TTRreports/HookLoaderReport/ZoneWisehookLoader";
import TransacationReport from "./Components/Pages/Reports/transcationReports/TransacationReport";
import TripTonnageDetailReport from "./Components/Pages/Reports/TTRreports/Trip&TonnageReport/TripTonnageDetailReport";
import { Navigate } from "react-router-dom";
import GVPsClearanceReport from "./Components/Pages/Reports/GvpReports/GVPsClearanceReport";
import GVPsClearanceReport_Old from "./Components/Pages/Reports/GvpReports/GVPsClearanceReport_old";
import GVPsReport_Date from "./Components/Pages/Reports/GvpReports/GVPsReport_date";
import AccessDenied from "./Components/Common/AccessDenies/AccessDenied";
import transferStationInchargeMaster from "./Components/Pages/TransferStationInchargeMaster/transferStationInchargeMaster";
import hookLoaderReport from "./Components/Pages/Reports/TTRreports/HookLoaderReport/hookLoaderReport";
import SecondaryCollectionDeploymentReport from "./Components/Pages/Reports/TransactionReports/secondaryDeploymentReport";
import PrimaryDeploymentTransactionReport from "./Components/Pages/Reports/TransactionReports/primaryDeploymentReport";
import deployedHookLoaderReport from "./Components/Pages/Reports/TransactionReports/deployedHookLoaderReport";
import secondaryCollectionTransaction from "./Components/Pages/Reports/TransactionReports/secondaryCollectionTransaction";
import deployedContainerTransaction from "./Components/Pages/Reports/TransactionReports/deployedContainerTransaction";
import transferStationTransaction from "./Components/Pages/Reports/TransactionReports/transferStationTransaction";
import containerHookloaderMapping from "./Components/Pages/Reports/TransactionReports/containerHookloaderMapping";
import GVPsMaster from "./Components/Pages/Reports/GvpReports/GVPsMaster";
import GVPsReport from "./Components/Pages/Reports/GvpReports/GVPsReport";
import TeritaryDashboardReport from "./Components/Pages/Dashboards/teritaryDashboardReport";
import geofenceSummaryData from "./Components/Pages/Reports/GeofenceReports/geofenceSummaryData";
import geofenceVehicleReportData from "./Components/Pages/Reports/GeofenceReports/geofenceVehicleReportData";
import ViewDeployedTssctpReport from "./Components/Pages/Reports/ScvReports/viewDeployedTssctpReport";
import ViewInnerSCVsCircleReport from "./Components/Pages/Reports/ScvReports/viewInnerReportSCVsCircle";
import SCVInnerCircleReports from "./Components/Pages/Reports/ScvReports/viewInnerCircleReport";
import SCVOverallTrips from "./Components/Pages/Reports/ScvReports/scvOverallTrips";
import SCVOverallTripsView from "./Components/Pages/Reports/ScvReports/viewOverallScvsTrips";
import ViewInnerGVPClearenceReport from "./Components/Pages/Reports/GvpReports/viewGvpsReportDetails";
import MultiClearenceInnerGvpReport from "./Components/Pages/Reports/GvpReports/multiClearenceInnerReport";
import MultiClearenceInnerZoneAndCircleGvpReport from "./Components/Pages/Reports/GvpReports/multiClearenceGvpInnerReport";
import GvpInnerCircleReport from "./Components/Pages/Reports/GvpReports/gvpInnerCircleReport";
import ViewZonedetailedreport from "./Components/Pages/Reports/SATReports/viewZonedetailedreport";
import ViewSatVehiclereport from "./Components/Pages/Reports/SATReports/viewSatVehiclereport";
import ReportedWardreport from "./Components/Pages/Reports/SATReports/viewWardReport";
import ViewinnerVehicleReport from "./Components/Pages/Reports/ScvReports/viewInnerVehicleReport";
import UnderRepairReport from "./Components/Pages/Reports/SATReports/underRepairReport";
import ActiveReport from "./Components/Pages/Reports/SATReports/activeReport";
import TotalReport from "./Components/Pages/Reports/SATReports/totalReport";
import GvpInnerClearedReport from "./Components/Pages/Reports/GvpReports/gvpInnerClearedReport";
import gvpInnerExistingReport from "./Components/Pages/Reports/GvpReports/gvpInnerExistingReport";
import GvpInnerExistingReport from "./Components/Pages/Reports/GvpReports/gvpInnerExistingReport";
import CircleWiseTotalReport from "./Components/Pages/Reports/SATReports/circleTotalReports";
import CircleWiseTotalTotalReport from "./Components/Pages/Reports/SATReports/circleTotalReports";
import CondemnedWiseTotalReport from "./Components/Pages/Reports/SATReports/condemedCirclereport";
import CondemnedWiseTotalReportCircle from "./Components/Pages/Reports/SATReports/condemedCirclereport";
import UnderRepairCircleReport from "./Components/Pages/Reports/SATReports/underrepairCircle";
import UnderRepairCircleReportTotal from "./Components/Pages/Reports/SATReports/underrepairCircle";
import ActiveCircleReport from "./Components/Pages/Reports/SATReports/circleActive";
import SCVDeployedTripsView from "./Components/Pages/Reports/ScvReports/viewDeployedTrips";

import ViewGVPClearenceReport from "./Components/Pages/Reports/ScvReports/viewGvpClearenceReport";

import ReportedTSNotWardZone from "./Components/Pages/Reports/SATReports/reportedTSnotWard";
import ReportedTSNotWardCircle from "./Components/Pages/Reports/SATReports/reportedTSatWardCircle";
import ReportedTSNotWardCircleTotal from "./Components/Pages/Reports/SATReports/reportedTSatWardCircle";
import ReportedAtWardCircle from "./Components/Pages/Reports/SATReports/reportedAtWard";
import ReportedAtWardCircleTotal from "./Components/Pages/Reports/SATReports/reportedAtWard";
import ReportedWardAndTS from "./Components/Pages/Reports/SATReports/reportedAtWardTS";
import ReportedWardAndTSCircle from "./Components/Pages/Reports/SATReports/reportedAtwardTSCircle";
import ReportedWardAndTSCircleTotal from "./Components/Pages/Reports/SATReports/reportedAtwardTSCircle";
import NotReportedAtWard from "./Components/Pages/Reports/SATReports/NotReportedAtWard";
import NotReportedWardCircle from "./Components/Pages/Reports/SATReports/notReportedAtWardCircle";
import NotReportedWardCircleTotal from "./Components/Pages/Reports/SATReports/notReportedAtWardCircle";
import ReportedAtWardNotTS from "./Components/Pages/Reports/SATReports/reportedwardnotTS";
import ReportedAtWardNotTSCircle from "./Components/Pages/Reports/SATReports/reportedwardNotTSCircle";
import ReportedAtWardNotTSCircleTotal from "./Components/Pages/Reports/SATReports/reportedwardNotTSCircle";
import GvpDashboardReport from "./Components/Pages/Dashboards/GvpDashboard";
import MultiClearenceExistingGvpInnerGvpReport from "./Components/Pages/Reports/GvpReports/multiClearenceExistingGvpInnerReport";
import SatsDashboard from "./Components/Pages/Dashboards/SatsDashboard";
import ScvsDashboard from "./Components/Pages/Dashboards/ScvsDashboard";
import InactiveReportZone from "./Components/Pages/Reports/SATReports/inActiveZone";
import InactiveReportCircle from "./Components/Pages/Reports/SATReports/inActivecircle";
import InactiveReportCircleTotal from "./Components/Pages/Reports/SATReports/inActivecircle";
import ActiveReportTotal from "./Components/Pages/Reports/SATReports/inActivecircle";
import geofenceVehicleSummaryData from "./Components/Pages/Reports/GeofenceReports/geofenceVehicleSummaryData";
import ScvCircleInnerNotReportedRCV from "./Components/Pages/Reports/ScvReports/ScvCircleInnerReportedVehicleRCV";
import ScvCircleInnerReportedVehicleRCV from "./Components/Pages/Reports/ScvReports/ScvCircleInnerReportedVehicleRCV";
import ScvCircleInnerAllotedVehicleRcv from "./Components/Pages/Reports/ScvReports/ScvCircleInnerAllotedVehicleRcv";
import ScvCircleInnerCollectionPointTrans from "./Components/Pages/Reports/ScvReports/ScvCircleInnerCollectionPointTrans";
import SCVCircleNotReportedRcv from "./Components/Pages/Reports/ScvReports/scvCircleNotReportedRcv";
import loadingEquipmentClearenceReport from "./Components/Pages/Reports/LoadingEquipmentReports/loadingEquipmentClearenceReport";
import LoadingEquipmentInnercertification from "./Components/Pages/Reports/LoadingEquipmentReports/loadingEquipmentInnercertification";
import loadingEquipmentCertificationReport from "./Components/Pages/Reports/LoadingEquipmentReports/loadingEquipmentCertificationReport";
import loadingEquipmentDriverDetails from "./Components/Pages/LoadingEquipmentDriverDetails/loadingEquipmentDriverDetails";
import ZoneWiseTrips from "./Components/Pages/Reports/TTRreports/Trip&TonnageReport/zonewisetrips";
import ZoneWiseContanerTrips from "./Components/Pages/Reports/TTRreports/ContainerReport/zoneWiseContainerReport";
import ZoneWiseHookLoaderReport from "./Components/Pages/Reports/TTRreports/HookLoaderReport/zonewiseHookloader";
import GhmcTripsTonnageReport from "./Components/Pages/Reports/TTRreports/Trip&TonnageReport/GhmcTripsTonnageReport";
import HireTripsTonnageReport from "./Components/Pages/Reports/TTRreports/Trip&TonnageReport/HireTripsTonnageReport";
import HimswTripsTonnageReport from "./Components/Pages/Reports/TTRreports/Trip&TonnageReport/HimswTripsTonnage";
import TotalTripsTonnageReport from "./Components/Pages/Reports/TTRreports/Trip&TonnageReport/TotalTripsTonnage";
import GhmcTonnageReport from "./Components/Pages/Reports/TTRreports/Trip&TonnageReport/GhmcTonnage";
import HireTonnageReport from "./Components/Pages/Reports/TTRreports/Trip&TonnageReport/HireTonnage";
import HimswTonnageReport from "./Components/Pages/Reports/TTRreports/Trip&TonnageReport/HimswTonnage";
import TotalTonsReport from "./Components/Pages/Reports/TTRreports/Trip&TonnageReport/TotalTonnage";
import UlbZoneReport from "./Components/Pages/Reports/TTRreports/Trip&TonnageReport/UlbZoneReport";
import MobileAPKs from "./Components/APK's/mobileAPK's";
import TrafficMarshlTransactionReport from "./Components/Pages/Reports/TransactionReports/TrafficMarshal";
import TrafficMarshal from "./Components/Pages/TrafficMarshal/TrafficMarshal";
import CumulativeOperationReport from "./Components/Pages/Reports/TrafficMarshalReports/trafficMarshal";
import VehicleTotalWeightment from "./Components/Pages/Reports/TrafficMarshalReports/vehicleTotal";
import UnloadingWaitTime from "./Components/Pages/Reports/TrafficMarshalReports/unloadingWaitTime";
import ContractorWiseLoadingReport from "./Components/Pages/Reports/LoadingEquipmentReports/contractorWiseloadingEquipment";
import GVPsClearanceDateReport from "./Components/Pages/Reports/GvpReports/GVPsClearanceDateReport";
import { GetAllRolePermissions } from "./Components/Apis/loginApi";
import loadingEquipmentDeploymentSummaryReport from "./Components/Pages/Reports/LoadingEquipmentReports/loadingEquipmentDeploymentSummaryReport";
import TertiaryDeploymentDetails from "./Components/Pages/Reports/TertiaryReports/TeritaryDeploymentDetails";
import TertiaryTripDetails from "./Components/Pages/Reports/TertiaryReports/TeritaryTripDetails";
import DeploymentSummaryReport from "./Components/Pages/Reports/TertiaryReports/DeploymentSummary";
import { LogoutUser } from "./Components/Apis/loginApi";
import TertiaryDeploymentReport from "./Components/Pages/Reports/TertiaryReports/teritaryDeploymentReport";
import TertiaryTripDetailsReport from "./Components/Pages/Reports/TertiaryReports/TeritaryTrip_report";
import InnerReportDeployedTS from "./Components/Pages/Reports/TertiaryReports/InnerDeployTS";
import InnerReportDeployedJN from "./Components/Pages/Reports/TertiaryReports/InnerDeployReportJN";
import InnerReportDeployedHalting from "./Components/Pages/Reports/TertiaryReports/IsHaultingInnerReport";
import InnerReportOfTotalDeployment from "./Components/Pages/Reports/TertiaryReports/InnerTotalDeployment";
import ActiveUsers from "./Components/Pages/ActiveUsers/activeUsers";
import GVPClearanceMapView from "./Components/Pages/Reports/GvpReports/GVPClearanceMapView";
import GVPInnerCount from "./Components/Pages/Reports/GvpReports/GVPInnerCount";
import CollectionTypeInnerCount from "./Components/Pages/Reports/GvpReports/CollectionTypeInnerCount";
import LiveReports from "./Components/Pages/Reports/TrafficMarshalReports/LiveReports";
import LiveInnerReport from "./Components/Pages/Reports/TrafficMarshalReports/LiveInnerReport";
import SummaryReports from "./Components/Pages/Reports/TrafficMarshalReports/SummaryReports";
import GVPInnerClearancePendingReport from "./Components/Pages/Reports/GvpReports/GVPInnerClearancePendingReport";
import GVPHotspotInnerCount from "./Components/Pages/Reports/GvpReports/GVPHotspotInnerReport";
import isGHMC from "./Components/Common/helper/helpar";
import SATTotalTripReport from "./Components/Pages/Reports/SATReports/SATTripToTSSCTP/SATTotalTripReport/SATTotalTripReport";
import SATTripReport from "./Components/Pages/Reports/SATReports/SATTripToTSSCTP/SATTripReport/SATTripReport";
import SATZoneInnerCircleReport from "./Components/Pages/Reports/SATReports/SATTripToTSSCTP/ZoneWiseSATsReports/SATZoneInnerCircleReport/SATZoneInnerCircleReport";
import SATZoneInnerCircleZoneReport from "./Components/Pages/Reports/SATReports/SATTripToTSSCTP/ZoneWiseSATsReports/SATZoneInnerCircleZoneReport/SATZoneInnerCircleZoneReport";
import SFAAppPrivacyPolicy from "./Components/Common/PrivacyPolicies/SFAAppPrivacyPolicy";
import GVPAppPrivacyPolicy from "./Components/Common/PrivacyPolicies/GVPAppPrivacyPolicy";
import TransferStationAppPrivacyPolicy from "./Components/Common/PrivacyPolicies/TransferStationAppPrivacyPolicy";
import TrafficMarshalAppPrivacyPolicy from "./Components/Common/PrivacyPolicies/TrafficMarshalAppPrivacyPolicy";
import LoadingEquipmentAppPrivacyPolicy from "./Components/Common/PrivacyPolicies/LoadingEquipmentAppPrivacyPolicy";
import SecondaryAppPrivacyPolicy from "./Components/Common/PrivacyPolicies/SecondaryAppPrivacyPolicy";
import TertiaryDeploymentAppPrivacyPolicy from "./Components/Common/PrivacyPolicies/TertiaryDeploymentAppPrivacyPolicy";
import TransferstationCategory from "./Components/Pages/TransferstationCategory/transferstationCategory";
import { HygieneObservation } from "./Components/Pages/HygieneObservation/HygieneObservation";
import { IndependentEngineer } from "./Components/Pages/IndependentEngineer/IndependentEngineer";
import { GrievanceDetailedReport } from "./Components/Pages/Reports/GrievanceDetailedReport/grievanceDetailedReport";
import AttendanceSummaryReport from "./Components/Pages/Reports/Attendance/AttendanceSummaryReport/AttendanceSummaryReport";
import DailyReport from "./Components/Pages/Reports/Attendance/DailyReport";
import ZoneLevelDrillDown from "./Components/Pages/Reports/Attendance/AttendanceSummaryReport/ZoneLevelDrillDown";
import SupportingStaffDrillDown from "./Components/Pages/Reports/Attendance/AttendanceSummaryReport/SupportingStaffDrillDown";
import MonthWiseAttendanceSummary from "./Components/Pages/Reports/Attendance/MonthWiseAttendanceSummary/MonthWiseAttendanceSummary";
import Employee from "./Components/Pages/Attendance/Employee/Employee";
import Designation from "./Components/Pages/Attendance/Designations/Designations";
import Operations from "./Components/Pages/Attendance/Operations/Operations";
import TippingFee from "./Components/Pages/KPIs/TippingFee/tippingFee";
import TippingFeeCalculationReport from "./Components/Pages/Reports/KPIReports/TippingFeeCalculationReport/TippingFeeCalculationReport";
import TippingFeeCalculationInnerReport from "./Components/Pages/Reports/KPIReports/TippingFeeCalculationReport/TippingFeeCalculationInnerReport";
import TonnageCompositionReport from "./Components/Pages/Reports/KPIReports/TonnageCompositionReport/TonnageCompositionReport";
import { HygieneTransportationReport } from "./Components/Pages/Reports/KPIReports/HygieneReport/HygieneReport";
import { FrequencyOfBinsReport } from "./Components/Pages/Reports/KPIReports/FrequencyBinsReport/frequencyBinsReport";
import FrequencyBinsInnerReport from "./Components/Pages/Reports/KPIReports/FrequencyBinsReport/FrequencyBinsInnerReport";
import { MSWManagementVehiclesOnRoad } from "./Components/Pages/Reports/KPIReports/MSWManagementVehicles/MSWManagementVehiclesReport";
import { MSWManagementVehiclesOnRoadInnerReport } from "./Components/Pages/Reports/KPIReports/MSWManagementVehicles/MSWManagementVehicleInnerReport";
import MSWManagementMainReport from "./Components/Pages/Reports/KPIReports/MSWManagementVehicles/MSWManagementMainReport";
import MSWManagementTertiaryMainReport from "./Components/Pages/Reports/KPIReports/MSWManagementTertiaryVehicles/MSWManagementTertiaryMainReport";
import { MSWManagementTertiaryVehiclesOnRoadInnerReport } from "./Components/Pages/Reports/KPIReports/MSWManagementTertiaryVehicles/MSWManagementTertiaryVehicleInnerReport";
import { TransferStationDetailedReportTSSCTP } from "./Components/Pages/Reports/KPIReports/TransferstationManagementReports/DetailedReportForTransferstationManagementReport";
import TransferstationManagementMonthlyReport from "./Components/Pages/Reports/KPIReports/TransferstationManagementReports/TransferstationManagementMonthlyReport";
import { NoOfBinsReport } from "./Components/Pages/Reports/KPIReports/NoOfBinsReport/NoofBinsReport";
import { NoOfBinsInnerReport } from "./Components/Pages/Reports/KPIReports/NoOfBinsReport/NoofBinsInnerReport";
import GvpNotClearedInnerReport from "./Components/Pages/Reports/GvpReports/GvpNotClearedReport";
import GvpInnerClearedNotInShiftReport from "./Components/Pages/Reports/GvpReports/gvpclearedNotInShift";
import GvpTotalClearedInnerReport from "./Components/Pages/Reports/GvpReports/gvpTotalClearedInnerReport";
import ZoneAndVehicleWiseContainerReport from "./Components/Pages/Reports/TTRreports/ContainerReport/zoneAndVehicleWiseContainerReport";
import { DeployedVehiclesInnerReport } from "./Components/Pages/Reports/KPIReports/MSWManagementVehicles/DeployedVehiclesInnerReport";

const validPaths = [
  "/",
  "/country-master",
  "/state-master",
  "/city-master",
  "/city-details",
  "/organization-zone",
  "/zone-details",
  "/organization-circle",
  "/circle-details",
  "/organization-ward",
  "/ward-details",
  "/vehicles",
  "/vehicles-v1",
  "/view-vehicle-details",
  "/vehicle-type",
  "/container-type",
  "/vehicle-type-details",
  "/owner-type",
  "/owner-type-details",
  "/collection-type",
  "/roles",
  "/users",
  "/scv-drivers",
  "/driver-details",
  "/loading-equipment",
  "/shifts",
  "/view-shift-details",
  "/collection-points",
  "/view-collection-points-details",
  "/routes",
  "/route-master-details",
  "/transferStation",
  "/transferstation-incharge",
  "/transfer-station-details",
  "/Containers",
  "/container-details",
  "/deployment-locations",
  "/deployment-location-details",
  "/primary-deployment-charge-master",
  "/secondary-deployment-incharges",
  "/deployment-charge-details",
  "/companies",
  "/company-details",
  "/reports",
  "/vehicle-total-weightment",
  "/live-reports",
  "/live-inner-reports",
  "/summary-reports",
  "/unloading-wait-time",
  "/route-tracking",
  "/transfer-station-detail-report",
  "/scv-deployed-trips",
  "/scv-driver-data",
  "/overall-trips-ts/sctp",
  "/scv-master-data",
  // GVP
  "/gvp-report",
  "/gvp-master",
  "/gvp-clearance-report",
  "/gvp-clearence-report-old",
  "/gvp-multiple-clearence",
  "/gvp-day-clearence",
  "/gvp-not-clearence",
  "/gvp-route-map",
  "/trips-tonnage-reports",
  "/ts_sctp_trips_tonnage",
  "/trip_tonnage_detail_report",
  "/ts_sctp_ulb",
  "/hook_loader_report",
  "/container_report",
  "/primary-dashboard",
  "/teritary-dashboard",
  // "/vehicle_report",
  "/vehicle_hook",
  // reports routes
  "/day_detail_report",
  "/not_report_ward",
  "/daywise_not_report",
  "/week_daywise_pendency",
  "/report_at_ward",
  "/vehicle_master_report",
  "/tssctp_wise_report",
  "/deviation_report",
  "/trip_tssctp",
  // scv report
  "/scv_report_circle",
  "/scv_route_tracking",
  "/tssctp_view",
  "/vehicle-capacity",
  "/container-capacity",
  "/transaction-reports",
  "/primary-deployment-transaction-report",
  "/traffic-marshal-transaction-report",
  "/secondary-deployment-transaction-report",
  "/deployed-hookloader-report",
  "/secondary-collection-transaction",
  "/deployed-container-transaction",
  "/all-transferstation-transaction",
  "/container-hookloader-transaction",
  "/geofence-summary",
  "/geofence-vehicle-reports",
  "/deployed-trips-tssctp",
  "/view-scvs-circle-report",
  "/view-inner-scv-circle-report",
  "/view-overall-trips",
  "/view-gvp-clearence",
  "/multi-clearence--inner-report",
  "/multi-clearence-existing-gvp-inner-report",
  "/multi-clearence-gvp-inner-report",
  "/gvp-inner-circle-report",
  "/view-sat-zone-report",
  "/view-sat-vehicle-report",
  "/reported-ward-zone",
  "/view-vehicle-inner-report",
  "/sat-under-repair-report",
  "/sat-active-report",
  "/sat-total-report",
  "/gvp-inner-existing-report",
  "/gvp-inner-cleared-report",
  "/sat-circle-total-report",
  "/circle-condemned-report",
  "/circle-under-repair-report",
  "/circle-active-report",
  "/view-deployed-trips",
  "/cumulative-operation",
  "/view-Gvp-clearence-report",
  "/reported-ts-notward-zone",
  "/reported-ts-notward-circle",
  "/reported-ward-circle",
  "/reported-wardts-zone",
  "/reported-wardts-circle",
  "/not-reported-ward-zone",
  "/not-reported-ward-circle",
  "/reported-ward-notts-zone",
  "/reported-ward-notts-circle",
  "/gvp-dashboard",
  "/contractor-wise-report",
  "/sat-dashboard",
  "/scv-dashboard",
  "/sat-inactive-report",
  "/circle-inactive-report",
  "/geofence-vehicle-summary-reports",
  "/scv-circle-reported-vehicle-rcv",
  "/scv-circle-not-reported-rcv",
  "/view-circle-inner-vehicle-alloted-rcv",
  "/view-circle-inner-collection-point-trans",
  "/loading_equipment_clearence-report",
  "/loading_equipment_certification-report",
  "/loading_equipment_inner_certification-report",
  "/zone-trips-tonnage",
  "/zone-container_report",
  "/vehicle-container_report",
  "/zone-hookloader_report",
  "/vehicle-hookloader_report",
  "/ghmc-trips-tonnage",
  "/hire-trips-tonnage",
  "/himsw-trips-tonnage",
  "/total-trips-tonnage",
  "/ghmc-tonnage",
  "/hire-tonnage",
  "/himsw-tonnage",
  "/total-tonnage",
  "/zone-ulb",
  "/mobile-apk's",
  "/traffic-marshal",
  "/loading-equipment-driver-details",
  "/loading_equipment_deployment-summary-report",
  "/loading_equipment_clearance-report",
  "/sat-circle-total-wise-report",
  "/circle-condemned-circle-report",
  "/circle-under-repair-total-report",
  "/circle-inactive-total-report",
  "/circle-active-total-report",
  "/reported-ward-circle-total",
  "/not-reported-ward-circle-total",
  "/reported-wardts-circle-total",
  "/reported-ward-notts-circle-total",
  "/reported-ts-notward-circle-total",
  "/gvp-report-date",
  "/tertiary-deployment-details",
  "/tertiary-trip-details",
  "/deployment-summary",
  "/deployment-report-teritary",
  "/trip-report-teritary",
  "/summary-report-teritary",
  "/inner-teritory-deployedts",
  "/inner-teritory-deployedJN",
  "/inner-teritory-hatling-report",
  "/inner-teritory-hatling-report",
  "/inner-teritory-total-deployment",
  "/active-users",
  "/gvp-clearance-map-view",
  "/gvp-clearance-pending-report",
  "/gvp-hotspot-clearance-report",
  "/gvp-clearance-view-report",
  "/gvp-collection-report",
  "/sat-total-inner-trip-report",
  "/sat-inner-trip-report",
  "/sat-inner-circle-report",
  "/sat-inner-circle-zone-report",
  "/ts-feedback-category",
  "/hygiene-observation",
  "/independent-engineer",
  "/grievance-detailed-report",

  "/sat-circle-total-wise-report",
  "/circle-condemned-circle-report",
  "/circle-under-repair-total-report",
  "/circle-inactive-total-report",
  "/reported-ward-circle-total",
  "/not-reported-ward-circle-total",
  "/reported-wardts-circle-total",
  "/reported-ward-notts-circle-total",
  "/reported-ts-notward-circle-total",
  "/gvp-report-date",
  "/tertiary-deployment-details",
  "/tertiary-trip-details",
  "/deployment-summary",
  "/deployment-report-teritary",
  "/trip-report-teritary",
  "/summary-report-teritary",
  "/inner-teritory-deployedts",
  "/inner-teritory-deployedJN",
  "/inner-teritory-hatling-report",
  "/inner-teritory-hatling-report",
  "/inner-teritory-total-deployment",
  "/active-users",
  "/gvp-clearance-map-view",
  "/gvp-clearance-pending-report",
  "/gvp-hotspot-clearance-report",
  "/gvp-clearance-view-report",
  "/gvp-collection-report",
  "/sat-total-inner-trip-report",
  "/sat-inner-trip-report",
  "/sat-inner-circle-report",
  "/sat-inner-circle-zone-report",
  "/attendance-summary-report",
  "/attendance-daily-report",
  "/employee",
  "/operations",
  "/designations",
  "/month-wise-attendance-summary-report",
  "/zone-level-drill-down",
  "/supporting-staff-drill-down",
  "/tipping-fee",
  "/tipping-fee-calculation-report",
  "/inner-tipping-fee-calculation-report",
  "/tonnage-composition-report",
  "/hygiene-transportation-report",
  "/no-of-bins-report",
  "/inner-no-of-bins-gvp-report",
  "/frequency-bins-report",
  "/inner-frequency-bins-report",
  "/msw-management-vehicles-report",
  "/msw-management-vehicles-inner-report",
  "/deployed-inner-report",
  "/msw-management-tertiary-vehicles-report",
  "/msw-management-tertiary-vehicles-inner-report",
  "/transferstation-monthly-report",
  "/detailed-transferstation-TS/SCTP",
  "/gvp-not-cleared-inner-report",
  "/gvp-inner-cleared-not-shift-report",
  "/gvp-total-cleared-inner-report",
];

function App() {
  const location = useLocation();
  const isPathValid = validPaths.includes(location.pathname);
  const [data, setData] = useState([]);
  const isProd = isGHMC();
  // const fetchApiData = async (path) => {
  //   try {
  //     const response = await GetAllRolePermissions();
  //     // Handle the response as needed
  //     setData(response);
  //     sessionStorage.setItem('permissionsData', JSON.stringify(response));

  //   } catch (error) {
  //     console.error("Error fetching API data", error);
  //   }
  // };

  // Call API whenever location changes
  // useEffect(() => {
  //   if (validPaths.includes(location.pathname)) {
  //     fetchApiData(location.pathname);
  //   }
  // }, [location]);

  const [showModal, setShowModal] = useState(false);
  const [remainingTime, setRemainingTime] = useState(0);
  const idleTime = 0.5;

  const handleIdle = () => {
    setShowModal(true);
    setRemainingTime(idleTime * 60); // Convert idle time to seconds
  };
  const { isIdle } = useIdle({ onIdle: handleIdle, idleTime });
  useEffect(() => {
    let interval;
    if (isIdle && showModal) {
      interval = setInterval(() => {
        setRemainingTime((prev) => (prev > 0 ? prev - 1 : 0));
      }, 1000);
    }
    return () => clearInterval(interval);
  }, [isIdle, showModal]);
  // const handleLogout = () => {
  //   setShowModal(false);
  //   // Add your logout logic here
  // };
  const handleStayLoggedIn = () => {
    setShowModal(false);
    // Add any necessary logic to handle staying logged in
  };
  const [isLoggedIn, setIsLoggedIn] = useState(true); // Example state for logged in status

  const handleLogout = () => {
    // Handle logout logic
    localStorage.removeItem("token");
    //   localStorage.removeItem("isLoggedIn");
    setIsLoggedIn(false);
  };

  useEffect(() => {
    let inactivityTimeout;

    const resetTimeout = () => {
      clearTimeout(inactivityTimeout);
      inactivityTimeout = setTimeout(() => {
        localStorage.clear();
        handleLogout();
      }, 3600000); // 60 minutes
    };

    // Initial setup
    resetTimeout();

    window.addEventListener("mousemove", resetTimeout);
    window.addEventListener("keypress", resetTimeout);

    return () => {
      clearTimeout(inactivityTimeout);
      window.removeEventListener("mousemove", resetTimeout);
      window.removeEventListener("keypress", resetTimeout);
    };
  }, []);

  const [loginPermission, setLoginPermission] = useState([]);

  const updateLoginPermission = (permissions) => {
    setLoginPermission(permissions);
  };

  const withPermission = (WrappedComponent, requiredPermissions) => {
    const isLoggedIn = !!localStorage.getItem("token");
    const userAuth = localStorage.getItem("loginPermissions");
    const userPermissions = userAuth ? userAuth.split(",") : [];
    // Check if user is logged in and has the required permissions
    const hasPermission =
      isLoggedIn &&
      requiredPermissions.every((permission) =>
        userPermissions.includes(permission.trim()),
      );

    if (hasPermission) {
      // If user is logged in and has required permissions, render the component
      return <WrappedComponent />;
    } else {
      // If user is not logged in or does not have required permissions, redirect to home page
      return <Navigate to="/" replace />;
    }
  };
  // const permissionValues1 = JSON.parse(localStorage.getItem('rolePermissions')) || {};
  // const storedPermissionsData = JSON.parse(sessionStorage.getItem('permissionsData')) || [];

  // Initialize an array to store all found permissions
  const foundPermissions = [];

  // Iterate over permissionValues1 to find matching permissions in storedPermissionsData
  // storedPermissionsData.find(permission => {
  //   const foundPermission = permissionValues1.find(item => item.permissionId === permission.permissionId);
  //   if (foundPermission) {
  //     foundPermissions.push(foundPermission);
  //   }
  // });

  // Log all found permissions

  // Example: Logging canWrite values of all found permissions
  foundPermissions.forEach((permission) => {
    // console.log(`Permission ID: ${permission.permissionId}, Can Write: ${permission.canWrite}`);
  });

  // if (foundPermissions.length === 0) {
  //   console.log("Permission not found");
  // }

  return (
    <div className={`${isProd ? "ghmc-true" : "ghmc-false"} App`}>
      {/* <Loader/> */}
      {isLoggedIn && <IdleTimeoutModal handleLogout={handleLogout} />}
      <Suspense fallback={<div>Loading...</div>}>
        {isPathValid && location.pathname !== "/" && <Header />}
        {isPathValid && location.pathname !== "/" && (
          <Sidebar loginPermission={loginPermission} />
        )}
        <Routes>
          <Route
            path="/"
            element={
              <LoginForm
                updateLoginPermission={updateLoginPermission}
                validPaths={validPaths}
              />
            }
          />
          <Route
            path="/country-master"
            element={<PrivateRoute element={CountryMaster} />}
          />
          <Route
            path="/state-master"
            element={<PrivateRoute element={StateMaster} />}
          />
          <Route
            path="/city-master"
            element={<PrivateRoute element={CityMaster} />}
          />
          <Route
            path="/city-details"
            element={<PrivateRoute element={CityDetails} />}
          />
          <Route
            path="/companies"
            element={<PrivateRoute element={Company} />}
          />
          <Route
            path="/reported-ts-notward-circle"
            element={<PrivateRoute element={ReportedTSNotWardCircle} />}
          />
          <Route
            path="/reported-ts-notward-circle-total"
            element={<PrivateRoute element={ReportedTSNotWardCircleTotal} />}
          />
          <Route
            path="/reported-wardts-zone"
            element={<PrivateRoute element={ReportedWardAndTS} />}
          />
          <Route
            path="/reported-wardts-circle"
            element={<PrivateRoute element={ReportedWardAndTSCircle} />}
          />
          <Route
            path="/reported-wardts-circle-total"
            element={<PrivateRoute element={ReportedWardAndTSCircleTotal} />}
          />
          <Route
            path="/company-details"
            element={<PrivateRoute element={CompanyDetails} />}
          />
          <Route
            path="/reported-ward-notts-zone"
            element={<PrivateRoute element={ReportedAtWardNotTS} />}
          />
          <Route
            path="/reported-ward-notts-circle"
            element={<PrivateRoute element={ReportedAtWardNotTSCircle} />}
          />
          <Route
            path="/reported-ward-notts-circle-total"
            element={<PrivateRoute element={ReportedAtWardNotTSCircleTotal} />}
          />
          {/* <Route path="/city-structure-level" element={<CitystructureLevel />} /> */}
          <Route
            path="/organization-zone"
            // element={<PrivateRoute element={OrganizationZone} />}
            element={withPermission(OrganizationZone, ["Zone"])}
          />
          <Route
            path="/zone-details"
            element={<PrivateRoute element={ZoneDetails} />}
          />
          <Route
            path="/organization-circle"
            // element={<PrivateRoute element={OrganizationCircle} />}
            element={withPermission(OrganizationCircle, ["Circle "])}
          />
          <Route
            path="/circle-details"
            element={<PrivateRoute element={CircleDetails} />}
          />
          <Route
            path="/organization-ward"
            // element={<PrivateRoute element={OrganizationWard} />}
            element={withPermission(OrganizationWard, ["Ward"])}
          />
          <Route
            path="/ward-details"
            element={<PrivateRoute element={WardDetails} />}
          />
          {/* <Route path="/operations-master" element={<OperationMaster />} /> */}
          <Route
            path="/vehicle-type"
            // element={<PrivateRoute element={VehicleType} />}
            element={withPermission(VehicleType, ["Vehicle Type"])}
          />
          <Route
            path="/container-type"
            // element={<PrivateRoute element={VehicleType} />}
            element={withPermission(ContainerType, ["Container Type"])}
          />
          <Route
            path="/vehicle-capacity"
            // element={<PrivateRoute element={vehicleCapacity} />}
            element={withPermission(vehicleCapacity, ["Vehicle Capacity"])}
          />
          <Route
            path="/container-capacity"
            // element={<PrivateRoute element={vehicleCapacity} />}
            element={withPermission(containerCapacity, ["Container Capacity"])}
          />
          <Route
            path="/view-vehicle-type-details/:id"
            element={<PrivateRoute element={ViewVehicleTypeDetails} />}
          />
          <Route
            path="/vehicle-type-details"
            element={<PrivateRoute element={VehicleTypeDetails} />}
          />
          <Route
            path="/collection-type"
            element={<PrivateRoute element={CollectionType} />}
          />
          <Route
            path="/circle-under-repair-report"
            element={<PrivateRoute element={UnderRepairCircleReport} />}
          />
          <Route
            path="/circle-under-repair-total-report"
            element={<PrivateRoute element={UnderRepairCircleReportTotal} />}
          />
          <Route
            path="/owner-type"
            // element={<PrivateRoute element={OwnerType} />}
            element={withPermission(OwnerType, ["Owner Type"])}
          />
          <Route
            path="/owner-type-details"
            element={<PrivateRoute element={OwnerTypeDetails} />}
          />
          <Route
            path="/vehicles"
            // element={<PrivateRoute element={Vehicle} />}
            element={withPermission(Vehicle, ["Vehicles"])}
          />
          <Route
            path="/vehicles-v1"
            // element={<PrivateRoute element={Vehicle} />}
            element={VehicleV1}
          />
          <Route
            path="/view-vehicle-details"
            element={<PrivateRoute element={ViewVehicleDetails} />}
          />
          <Route
            path="/reported-ts-notward-zone"
            element={<PrivateRoute element={ReportedTSNotWardZone} />}
          />
          <Route
            path="/roles"
            element={withPermission(RoleCreation, ["Roles"])}
            // element={<PrivateRoute element={RoleCreation} />}
          />
          <Route
            path="/active-users"
            element={withPermission(ActiveUsers, ["Users"])}
          />

          <Route
            path="/collection-points"
            // element={<PrivateRoute element={GvpMaster} />}
            element={withPermission(GvpMaster, ["Collection Points"])}
          />
          <Route
            path="/users"
            element={withPermission(UserCreation, ["Users"])}
            // element={<PrivateRoute element={UserCreation} />}
          />
          <Route
            path="/scv-drivers"
            // element={<PrivateRoute element={DriverCreation} />}
            element={withPermission(DriverCreation, ["Drivers"])}
          />
          <Route
            path="/driver-details"
            element={<PrivateRoute element={ViewDriverDetails} />}
          />
          <Route
            path="/view-driver-details/:id"
            element={<PrivateRoute element={ViewDriverDetails} />}
          />
          <Route
            path="/mobile-apk's"
            // element={withPermission(MobileAPKs, ["MobileAPK's"])}
            element={<PrivateRoute element={MobileAPKs} />}
          />
          <Route
            path="/loading-equipment"
            // element={<PrivateRoute element={LoadingEquipment} />}
            element={withPermission(LoadingEquipment, ["Loading Equipments"])}
          />
          <Route
            path="/shifts"
            element={withPermission(ShiftMaster, ["Shifts"])}
            // element={<PrivateRoute element={ShiftMaster} />}
          />
          <Route
            path="/view-shift-details"
            element={<PrivateRoute element={ViewShiftDetails} />}
          />

          <Route
            path="/view-collection-points-details"
            element={<PrivateRoute element={ViewCollectionPointsDetails} />}
          />
          <Route
            path="/view-sat-zone-report"
            element={<PrivateRoute element={ViewZonedetailedreport} />}
          />
          <Route
            path="/sat-circle-total-report"
            element={<PrivateRoute element={CircleWiseTotalReport} />}
          />
          <Route
            path="/sat-circle-total-wise-report"
            element={<PrivateRoute element={CircleWiseTotalTotalReport} />}
          />
          <Route
            path="/circle-condemned-report"
            element={<PrivateRoute element={CondemnedWiseTotalReport} />}
          />

          <Route
            path="/circle-condemned-circle-report"
            element={<PrivateRoute element={CondemnedWiseTotalReportCircle} />}
          />
          <Route
            path="/routes"
            //  element={<PrivateRoute element={RouteMaster} />}
            element={withPermission(RouteMaster, ["Routes"])}
          />
          <Route
            path="/route-master-details"
            element={<PrivateRoute element={RouteDetails} />}
          />
          <Route
            path="/transferStation"
            // element={<PrivateRoute element={TransferStationMaster} />}
            element={withPermission(TransferStationMaster, ["TransferStation"])}
          />
          <Route
            path="/transferstation-incharge"
            element={withPermission(transferStationInchargeMaster, [
              "TransferStation InCharge",
            ])}
            // element={<PrivateRoute element={transferStationInchargeMaster} />}
          />

          <Route
            path="/loading-equipment-driver-details"
            // element={withPermission(loadingEquipmentDriverDetails, [
            //   "Loading Equipment Driver Details",
            // ])}
            //element={<PrivateRoute element={loadingEquipmentDriverDetails} />}
          />
          <Route
            path="/transfer-station-details"
            element={<PrivateRoute element={TransferStationDetails} />}
          />
          <Route
            path="/Containers"
            // element={<PrivateRoute element={ContainerMaster} />}
            element={withPermission(ContainerMaster, ["Containers"])}
          />
          <Route
            path="/container-details"
            element={<PrivateRoute element={ContainerDetails} />}
          />
          <Route
            path="/circle-active-report"
            element={<PrivateRoute element={ActiveCircleReport} />}
          />
          <Route
            path="/deployment-locations"
            // element={<PrivateRoute element={DeploymentLocationMaster} />}
            element={withPermission(DeploymentLocationMaster, [
              "Deployment Locations",
            ])}
          />

          <Route
            path="/ts-feedback-category"
            // element={<PrivateRoute element={TransferstationCategory} />}
            element={withPermission(TransferstationCategory, [
              "Transferstation Feedback Category",
            ])}
          />
          <Route
            path="/hygiene-observation"
            // element={<PrivateRoute element={HygieneObservation} />}
            element={withPermission(HygieneObservation, [
              "Hygiene Observation",
            ])}
          />

          <Route
            path="/independent-engineer"
            // element={<PrivateRoute element={IndependentEngineer} />}
            element={withPermission(IndependentEngineer, [
              "Independent Engineer",
            ])}
          />
          <Route
            path="/tipping-fee"
            element={<PrivateRoute element={TippingFee} />}
          />
          <Route
            path="/grievance-detailed-report"
            // element={<PrivateRoute element={GrievanceDetailedReport} />}
            element={withPermission(GrievanceDetailedReport, [
              "Grievance Detailed Report",
            ])}
          />
          <Route
            path="/tipping-fee-calculation-report"
            element={withPermission(TippingFeeCalculationReport, [
              "KPI-01 Tipping Fee Calculation Report",
            ])}
          />

          <Route
            path="/inner-tipping-fee-calculation-report"
            element={
              <PrivateRoute element={TippingFeeCalculationInnerReport} />
            }
          />
          <Route
            path="/tonnage-composition-report"
            element={withPermission(TonnageCompositionReport, [
              "Tonnage Composition Report",
            ])}
          />
          <Route
            path="/hygiene-transportation-report"
            element={withPermission(HygieneTransportationReport, [
              "KPI-07 Hygiene Transportation Report",
            ])}
          />
          <Route
            path="/no-of-bins-report"
            element={withPermission(NoOfBinsReport, [
              "KPI-02 No of Bins/GVPs Attended Daily Report",
            ])}
          />
          <Route
            path="/inner-no-of-bins-gvp-report"
            element={<PrivateRoute element={NoOfBinsInnerReport} />}
          />
          <Route
            path="/frequency-bins-report"
            element={withPermission(FrequencyOfBinsReport, [
              "KPI-03 Frequency Of Bins/GVPs Attended Daily Report",
            ])}
          />
          <Route
            path="/inner-frequency-bins-report"
            element={<PrivateRoute element={FrequencyBinsInnerReport} />}
          />
          <Route
            path="/msw-management-vehicles-report"
            element={withPermission(MSWManagementMainReport, [
              "KPI-05 MSW Management vehicles on the Road-Secondary Collection",
            ])}
          />
          
          <Route
            path="/msw-management-vehicles-inner-report"
            element={
              <PrivateRoute element={MSWManagementVehiclesOnRoadInnerReport} />
            }
          />
           <Route
            path="/deployed-inner-report"
            element={<PrivateRoute element={DeployedVehiclesInnerReport} />}
          />
          <Route
            path="/msw-management-tertiary-vehicles-report"
            element={withPermission(MSWManagementTertiaryMainReport, [
              "KPI-06 MSW Management vehicles on the Road-Tertiary Collection",
            ])}
          />
          <Route
            path="/msw-management-tertiary-vehicles-inner-report"
            element={
              <PrivateRoute
                element={MSWManagementTertiaryVehiclesOnRoadInnerReport}
              />
            }
          />
          <Route
            path="/transferstation-monthly-report"
            element={withPermission(TransferstationManagementMonthlyReport, [
              "KPI-10 Transfer Station Management Report",
            ])}
          />
          <Route
            path="/deployment-location-details"
            element={<PrivateRoute element={DeploymentLocationDetails} />}
          />
          <Route
            path="/primary-deployment-charge-master"
            // element={<PrivateRoute element={PrimaryDeploymentChargeMaster} />}
            element={withPermission(PrimaryDeploymentChargeMaster, [
              "SFA InCharges",
            ])}
          />
          <Route
            path="/secondary-deployment-incharges"
            element={withPermission(SecondaryDeploymentChargeMaster, [
              "Secondary Deployment InCharges",
            ])}
            // element={<PrivateRoute element={SecondaryDeploymentChargeMaster} />}
          />
          {/* <Route
            path="/deployment-charge-details"
            element={<PrivateRoute element={DeploymentChargeDetails} />}
          /> */}
          <Route
            path="/route-tracking"
            // element={<PrivateRoute element={RouteTracking} />}
            element={withPermission(RouteTracking, ["Route Tracking"])}
          />
          <Route
            path="/day_detail_report"
            element={withPermission(DetailedReport, ["SAT Detailed Report"])}
            // element={<PrivateRoute element={DetailedReport} />}
          />

          <Route
            path="/sat-total-report"
            element={<PrivateRoute element={TotalReport} />}
          />
          <Route
            path="/not-reported-ward-zone"
            element={<PrivateRoute element={NotReportedAtWard} />}
          />
          <Route
            path="/sat-inactive-report"
            element={<PrivateRoute element={InactiveReportZone} />}
          />
          <Route
            path="/circle-inactive-report"
            element={<PrivateRoute element={InactiveReportCircle} />}
          />
          <Route
            path="/circle-inactive-total-report"
            element={<PrivateRoute element={InactiveReportCircleTotal} />}
          />
          <Route
            path="/circle-active-total-report"
            element={<PrivateRoute element={ActiveReportTotal} />}
          />
          <Route
            path="/not-reported-ward-circle"
            element={<PrivateRoute element={NotReportedWardCircle} />}
          />
          <Route
            path="/gvp-report-date"
            element={withPermission(GVPsClearanceDateReport, [
              "GVPs Clearance Report - Date",
            ])}
          />
          <Route
            path="/not-reported-ward-circle-total"
            element={<PrivateRoute element={NotReportedWardCircleTotal} />}
          />
          <Route
            path="/report_at_ward"
            element={<PrivateRoute element={ReportAtWard} />}
          />
          <Route
            path="/vehicle_master_report"
            element={<PrivateRoute element={VehicleMasterSATReport} />}
          />
          <Route
            path="/tssctp_wise_report"
            element={<PrivateRoute element={TSSCTPWise} />}
          />
          <Route
            path="/deviation_report"
            element={<PrivateRoute element={Deviation} />}
          />
          <Route
            path="/trip_tssctp"
            element={withPermission(TripTSSCTP, ["SAT Trip to TS/SCTP"])}
            // element={<PrivateRoute element={TripTSSCTP} />}
          />
          <Route
            path="/sat-inner-circle-report"
            element={<PrivateRoute element={SATZoneInnerCircleReport} />}
          />
          <Route
            path="/sat-inner-circle-zone-report"
            element={<PrivateRoute element={SATZoneInnerCircleZoneReport} />}
          />
          <Route
            path="/sat-total-inner-trip-report"
            element={<PrivateRoute element={SATTotalTripReport} />}
          />
          <Route
            path="/sat-inner-trip-report"
            element={<PrivateRoute element={SATTripReport} />}
          />
          {/* reports */}
          <Route
            path="/scv_report_circle"
            element={withPermission(CircleReport, ["Reported SCVs at Circle"])}
            // element={<PrivateRoute element={CircleReport} />}
          />
          <Route
            path="/scv-deployed-trips"
            // element={<PrivateRoute element={SCVReports} />}
            element={withPermission(SCVReports, [
              "SCVs Deployed Trips to TS/SCTP",
            ])}
          />
          <Route
            path="/view-sat-vehicle-report"
            element={<PrivateRoute element={ViewSatVehiclereport} />}
          />
          <Route
            path="/reported-ward-zone"
            element={<PrivateRoute element={ReportedWardreport} />}
          />
          <Route
            path="/gvp-clearance-pending-report"
            element={<PrivateRoute element={GVPInnerClearancePendingReport} />}
          />
          <Route
            path="/gvp-hotspot-clearance-report"
            element={<PrivateRoute element={GVPHotspotInnerCount} />}
          />
          <Route
            path="/gvp-clearance-view-report"
            element={<PrivateRoute element={GVPInnerCount} />}
          />
          <Route
            path="/gvp-collection-report"
            element={<PrivateRoute element={CollectionTypeInnerCount} />}
          />
          <Route
            path="/reported-ward-circle"
            element={<PrivateRoute element={ReportedAtWardCircle} />}
          />
          <Route
            path="/reported-ward-circle-total"
            element={<PrivateRoute element={ReportedAtWardCircleTotal} />}
          />
          <Route
            path="/scv-driver-data"
            element={<PrivateRoute element={SCVDriverMasterReports} />}
          />
          <Route
            path="/overall-trips-ts/sctp"
            // element={<PrivateRoute element={SCVOverallTrips} />}
            element={withPermission(SCVOverallTrips, [
              "SCVs Overall Trips to TS/SCTP",
            ])}
          />
          <Route
            path="/scv_route_tracking"
            element={<PrivateRoute element={RouteTrackReport} />}
          />
          <Route
            path="/scv-master-data"
            element={<PrivateRoute element={SCVMasterData} />}
          />
          <Route
            path="/gvp-clearance-report"
            element={<PrivateRoute element={GVPsClearanceReport} />}
          />
          <Route
            path="/gvp-master"
            element={<PrivateRoute element={GVPsMaster} />}
          />
          <Route
            path="/gvp-report"
            // element={<PrivateRoute element={GVPsReport} />}
            element={withPermission(GVPsReport, ["GVPs Report"])}
          />

          <Route
            path="/gvp-clearence-report-old"
            element={<PrivateRoute element={GVPsClearanceReport_Old} />}
          />
          <Route
            path="/gvp-multiple-clearence"
            // element={<PrivateRoute element={GVPMultipleClearence} />}
            element={withPermission(GVPMultipleClearence, [
              "GVP Multiple Clearance Report",
            ])}
          />
          <Route
            path="/gvp-day-clearence"
            element={<PrivateRoute element={GVPDayClearence} />}
          />
          <Route
            path="/zone-trips-tonnage"
            element={<PrivateRoute element={ZoneWiseTrips} />}
          />
          <Route
            path="/gvp-not-clearence"
            element={<PrivateRoute element={GVPNotClearence} />}
          />
          <Route
            path="/transaction-reports"
            element={<PrivateRoute element={TransacationReport} />}
          />
          <Route
            path="/tssctp_view"
            element={<PrivateRoute element={TSSCTPView} />}
          />
          <Route
            path="/trips-tonnage-reports"
            element={withPermission(TripTonnage, ["Trips & Tonnage Reports"])}
            // element={<PrivateRoute element={TripTonnage} />}
          />
          <Route
            path="/zone-ulb"
            element={<PrivateRoute element={UlbZoneReport} />}
          />
          <Route
            path="/hook_loader_report"
            // element={<PrivateRoute element={hookLoaderReport} />}
            element={withPermission(hookLoaderReport, [
              "Hook Loader TTR Report",
            ])}
          />
          <Route
            path="/zone-hookloader_report"
            element={<PrivateRoute element={ZoneWiseHookLoaderReport} />}
          />
          <Route
            path="/vehicle-hookloader_report"
            element={<PrivateRoute element={Vehiclehook} />}
          />
          <Route
            path="/ts_sctp_trips_tonnage"
            element={<PrivateRoute element={TSSCTPForTT} />}
          />
          <Route
            path="/trip_tonnage_detail_report"
            element={<PrivateRoute element={TripTonnageDetailReport} />}
          />
          <Route
            path="/ghmc-trips-tonnage"
            element={<PrivateRoute element={GhmcTripsTonnageReport} />}
          />
          <Route
            path="/hire-trips-tonnage"
            element={<PrivateRoute element={HireTripsTonnageReport} />}
          />
          <Route
            path="/himsw-trips-tonnage"
            element={<PrivateRoute element={HimswTripsTonnageReport} />}
          />
          <Route
            path="/total-trips-tonnage"
            element={<PrivateRoute element={TotalTripsTonnageReport} />}
          />
          <Route
            path="/ghmc-tonnage"
            element={<PrivateRoute element={GhmcTonnageReport} />}
          />
          <Route
            path="/hire-tonnage"
            element={<PrivateRoute element={HireTonnageReport} />}
          />
          <Route
            path="/himsw-tonnage"
            element={<PrivateRoute element={HimswTonnageReport} />}
          />
          <Route
            path="/total-tonnage"
            element={<PrivateRoute element={TotalTonsReport} />}
          />
          <Route
            path="/ts_sctp_ulb"
            element={<PrivateRoute element={TSSCTPForULB} />}
          />
          {/* // HookLoaderReport */}
          {/* <Route
            path="/hook_loader_report"
            element={<PrivateRoute element={vehiclewiseHookLoader} />}
          /> */}
          <Route
            path="/container_report"
            element={withPermission(ContainerReport, ["Container TTR Report"])}
            // element={<PrivateRoute element={ContainerReport} />}
          />
          <Route
            path="/zone-container_report"
            element={<PrivateRoute element={ZoneWiseContanerTrips} />}
          />
          <Route
            path="/vehicle-container_report"
            element={
              <PrivateRoute element={ZoneAndVehicleWiseContainerReport} />
            }
          />
          <Route
            path="/primary-dashboard"
            element={withPermission(TransferStationDashboard, [
              "TS Primary Dashboard",
            ])}
            // element={<PrivateRoute element={TransferStationDashboard} />}
          />
          <Route
            path="/teritary-dashboard"
            element={withPermission(TeritaryDashboardReport, [
              "TS Teritary Dashboard",
            ])}
            // element={<PrivateRoute element={TeritaryDashboardReport} />}
          />
          <Route
            path="/gvp-dashboard"
            element={withPermission(GvpDashboardReport, ["GVPs Dashboard"])}
            // element={<PrivateRoute element={GvpDashboardReport} />}
          />
          <Route
            path="/sat-dashboard"
            element={withPermission(SatsDashboard, ["SATs Dashboard"])}
            // element={<PrivateRoute element={SatsDashboard} />}
          />

          <Route
            path="/scv-dashboard"
            element={withPermission(ScvsDashboard, ["SCVs Dashboard"])}
            // element={<PrivateRoute element={ScvsDashboard} />}
          />
          <Route
            path="/primary-deployment-transaction-report"
            element={withPermission(PrimaryDeploymentTransactionReport, [
              "Primary Deployment Transaction Report",
            ])}
            // element={
            //   <PrivateRoute element={PrimaryDeploymentTransactionReport} />
            // }
          />
          <Route
            path="/traffic-marshal-transaction-report"
            element={withPermission(TrafficMarshlTransactionReport, [
              "Traffic Marshal Transaction Report",
            ])}
            // element={
            // <PrivateRoute element={TrafficMarshlTransactionReport} />
            // }
          />
          <Route
            path="/traffic-marshal"
            element={withPermission(TrafficMarshal, ["Traffic Marshal"])}
            //  element={
            //   <PrivateRoute element={TrafficMarshal} />
            // }
          />
          <Route
            path="/secondary-deployment-transaction-report"
            element={withPermission(SecondaryCollectionDeploymentReport, [
              "Secondary Deployment Transaction Report",
            ])}
            // element={
            //   <PrivateRoute element={SecondaryCollectionDeploymentReport} />
            // }
          />
          <Route
            path="/tertiary-deployment-details"
            element={withPermission(TertiaryDeploymentDetails, [
              "Tertiary Deployment",
            ])}
            // element={<PrivateRoute element={TertiaryDeploymentDetails} />}
          />
          <Route
            path="/deployment-report-teritary"
            //element={withPermission(TertiaryDeploymentDetails, ["Tertiary Deployment"])}
            element={<PrivateRoute element={TertiaryDeploymentReport} />}
          />
          <Route
            path="/trip-report-teritary"
            //element={withPermission(TertiaryDeploymentDetails, ["Tertiary Deployment"])}
            element={<PrivateRoute element={TertiaryTripDetailsReport} />}
          />
          <Route
            path="/tertiary-trip-details"
            element={withPermission(TertiaryTripDetails, ["Tertiary Trip"])}
            //  element={<PrivateRoute element={TertiaryTripDetails} />}
          />
          <Route
            path="/deployed-hookloader-report"
            element={withPermission(deployedHookLoaderReport, [
              "Deloyment Hookloader Report",
            ])}
            // element={<PrivateRoute element={deployedHookLoaderReport} />}
          />
          <Route
            path="/secondary-collection-transaction"
            // element={<PrivateRoute element={secondaryCollectionTransaction} />}
            element={withPermission(secondaryCollectionTransaction, [
              "Secondary Collection Transaction",
            ])}
          />
          <Route
            path="/deployed-container-transaction"
            element={withPermission(deployedContainerTransaction, [
              "Deployed Container Transaction",
            ])}
            // element={<PrivateRoute element={deployedContainerTransaction} />}
          />
          <Route
            path="/all-transferstation-transaction"
            element={withPermission(transferStationTransaction, [
              "All Transfertation Transaction",
            ])}
            // element={<PrivateRoute element={transferStationTransaction} />}
          />
          <Route
            path="/geofence-summary"
            element={withPermission(geofenceSummaryData, ["Geofence Summary"])}
            // element={<PrivateRoute element={geofenceSummaryData} />}
          />
          <Route
            path="/cumulative-operation"
            // element={withPermission(geofenceSummaryData, ["Geofence Summary"])}
            element={<PrivateRoute element={CumulativeOperationReport} />}
          />
          <Route
            path="/contractor-wise-report"
            // element={withPermission(geofenceSummaryData, ["Geofence Summary"])}
            element={<PrivateRoute element={ContractorWiseLoadingReport} />}
          />
          <Route
            path="/vehicle-total-weightment"
            // element={withPermission(geofenceSummaryData, ["Geofence Summary"])}
            element={<PrivateRoute element={VehicleTotalWeightment} />}
          />
          <Route
            path="/summary-report-teritary"
            //element={withPermission(DeploymentSummaryReport, ["Teritary Reports"])}
            element={<PrivateRoute element={DeploymentSummaryReport} />}
          />
          <Route
            path="/inner-teritory-deployedts"
            //element={withPermission(DeploymentSummaryReport, ["Teritary Reports"])}
            element={<PrivateRoute element={InnerReportDeployedTS} />}
          />
          <Route
            path="/inner-teritory-deployedJN"
            //element={withPermission(DeploymentSummaryReport, ["Teritary Reports"])}
            element={<PrivateRoute element={InnerReportDeployedJN} />}
          />
          <Route
            path="/inner-teritory-hatling-report"
            //element={withPermission(DeploymentSummaryReport, ["Teritary Reports"])}
            element={<PrivateRoute element={InnerReportDeployedHalting} />}
          />
          <Route
            path="/inner-teritory-total-deployment"
            //element={withPermission(DeploymentSummaryReport, ["Teritary Reports"])}
            element={<PrivateRoute element={InnerReportOfTotalDeployment} />}
          />
          <Route
            path="/unloading-wait-time"
            // element={withPermission(geofenceSummaryData, ["Geofence Summary"])}
            element={<PrivateRoute element={UnloadingWaitTime} />}
          />
          <Route
            path="/live-reports"
            element={<PrivateRoute element={LiveReports} />}
          />
          <Route
            path="/live-inner-reports"
            element={<PrivateRoute element={LiveInnerReport} />}
          />
          <Route
            path="/summary-reports"
            element={<PrivateRoute element={SummaryReports} />}
          />
          <Route
            path="/geofence-vehicle-reports"
            element={withPermission(geofenceVehicleReportData, [
              "Geofence Vehicle Report",
            ])}
            // element={<PrivateRoute element={geofenceVehicleReportData} />}
          />
          <Route
            path="/geofence-vehicle-summary-reports"
            element={withPermission(geofenceVehicleSummaryData, [
              "Geofence Vehicle Summary Report",
            ])}
            // element={<PrivateRoute element={geofenceVehicleSummaryData} />}
          />
          <Route
            path="/container-hookloader-transaction"
            element={withPermission(containerHookloaderMapping, [
              "Container HookLoader Transaction",
            ])}
            // element={<PrivateRoute element={containerHookloaderMapping} />}
          />
          <Route
            path="/deployed-trips-tssctp"
            element={<PrivateRoute element={ViewDeployedTssctpReport} />}
          />
          <Route
            path="/view-scvs-circle-report"
            element={<PrivateRoute element={ViewInnerSCVsCircleReport} />}
          />
          <Route
            path="/sat-under-repair-report"
            element={<PrivateRoute element={UnderRepairReport} />}
          />
          <Route
            path="/sat-active-report"
            element={<PrivateRoute element={ActiveReport} />}
          />
          <Route
            path="/view-gvp-clearence"
            element={<PrivateRoute element={ViewInnerGVPClearenceReport} />}
          />
          <Route
            path="/view-inner-scv-circle-report"
            element={<PrivateRoute element={SCVInnerCircleReports} />}
          />
          <Route
            path="/multi-clearence--inner-report"
            element={<PrivateRoute element={MultiClearenceInnerGvpReport} />}
          />
          <Route
            path="/gvp-clearance-map-view"
            element={<PrivateRoute element={GVPClearanceMapView} />}
          />
          <Route
            path="/multi-clearence-existing-gvp-inner-report"
            element={
              <PrivateRoute element={MultiClearenceExistingGvpInnerGvpReport} />
            }
          />
          <Route
            path="/loading_equipment_deployment-summary-report"
            element={withPermission(loadingEquipmentDeploymentSummaryReport, [
              "Loading Equipment Report",
            ])}
            // element={<PrivateRoute element={loadingEquipmentClearenceReport} />}
          />
          <Route
            path="/loading_equipment_clearance-report"
            // element={withPermission(loadingEquipmentClearenceReport, [
            //   "Loading Equipment Clearance Report",
            // ])}
            element={<PrivateRoute element={loadingEquipmentClearenceReport} />}
          />

          <Route
            path="/loading_equipment_certification-report"
            element={withPermission(loadingEquipmentCertificationReport, [
              "Loading Equipment Certification",
            ])}
            // element={<PrivateRoute element={loadingEquipmentCertificationReport} />}
          />
          <Route
            path="/loading_equipment_inner_certification-report"
            // element={withPermission(LoadingEquipmentInnercertification, [
            //   "Loading Equipment Certification",
            // ])}
            // element={<PrivateRoute element={loadingEquipmentCertificationReport} />}
            // element={withPermission(LoadingEquipmentInnercertification, [
            //   "Loading Equipment Certification",
            // ])}
            element={
              <PrivateRoute element={LoadingEquipmentInnercertification} />
            }
          />
          <Route
            path="/multi-clearence-gvp-inner-report"
            element={
              <PrivateRoute
                element={MultiClearenceInnerZoneAndCircleGvpReport}
              />
            }
          />
          <Route
            path="/gvp-inner-circle-report"
            element={<PrivateRoute element={GvpInnerCircleReport} />}
          />
          <Route
            path="/gvp-inner-cleared-report"
            element={<PrivateRoute element={GvpInnerClearedReport} />}
          />
          <Route
            path="/gvp-inner-cleared-not-shift-report"
            element={<PrivateRoute element={GvpInnerClearedNotInShiftReport} />}
          />
          <Route
            path="/gvp-total-cleared-inner-report"
            element={<PrivateRoute element={GvpTotalClearedInnerReport} />}
          />
          <Route
            path="/gvp-not-cleared-inner-report"
            element={<PrivateRoute element={GvpNotClearedInnerReport} />}
          />
          <Route
            path="/scv-circle-reported-vehicle-rcv"
            element={<PrivateRoute element={ScvCircleInnerAllotedVehicleRcv} />}
          />
          <Route
            path="/scv-circle-not-reported-rcv"
            element={<PrivateRoute element={SCVCircleNotReportedRcv} />}
          />
          <Route
            path="/view-circle-inner-vehicle-alloted-rcv"
            element={
              <PrivateRoute element={ScvCircleInnerReportedVehicleRCV} />
            }
          />
          <Route
            path="/view-circle-inner-collection-point-trans"
            element={
              <PrivateRoute element={ScvCircleInnerCollectionPointTrans} />
            }
          />
          <Route
            path="/gvp-inner-existing-report"
            element={<PrivateRoute element={GvpInnerExistingReport} />}
          />
          <Route
            path="/view-overall-trips"
            element={<PrivateRoute element={SCVOverallTripsView} />}
          />
          <Route
            path="/view-vehicle-inner-report"
            element={<PrivateRoute element={ViewinnerVehicleReport} />}
          />
          <Route
            path="/view-deployed-trips"
            element={<PrivateRoute element={SCVDeployedTripsView} />}
          />
          <Route
            path="/view-Gvp-clearence-report"
            element={<PrivateRoute element={ViewGVPClearenceReport} />}
          />
          <Route
            path="/attendance-summary-report"
            element={<PrivateRoute element={AttendanceSummaryReport} />}
          />
          <Route
            path="/zone-level-drill-down"
            element={<PrivateRoute element={ZoneLevelDrillDown} />}
          />
          <Route
            path="/supporting-staff-drill-down"
            element={<PrivateRoute element={SupportingStaffDrillDown} />}
          />
          <Route
            path="/attendance-daily-report"
            element={<PrivateRoute element={DailyReport} />}
          />
          <Route
            path="/employee"
            element={<PrivateRoute element={Employee} />}
          />
          <Route
            path="/operations"
            element={<PrivateRoute element={Operations} />}
          />
          <Route
            path="/designations"
            element={<PrivateRoute element={Designation} />}
          />
          <Route
            path="/month-wise-attendance-summary-report"
            element={<PrivateRoute element={MonthWiseAttendanceSummary} />}
          />
          <Route path="*" element={<NotFound />} />
          <Route path="/access-denied" element={<AccessDenied />} />
          <Route
            path="/sfa-app-privacy-policy"
            element={<SFAAppPrivacyPolicy />}
          />
          <Route
            path="/gvp-app-privacy-policy"
            element={<GVPAppPrivacyPolicy />}
          />
          <Route
            path="/tertiary-deployment-app-privacy-policy"
            element={<TertiaryDeploymentAppPrivacyPolicy />}
          />
          <Route
            path="/transfer-station-app-privacy-policy"
            element={<TransferStationAppPrivacyPolicy />}
          />
          <Route
            path="/traffic-marshal-app-privacy-policy"
            element={<TrafficMarshalAppPrivacyPolicy />}
          />
          <Route
            path="/loading-equipment-app-privacy-policy"
            element={<LoadingEquipmentAppPrivacyPolicy />}
          />
          <Route
            path="/secondary-app-privacy-policy"
            element={<SecondaryAppPrivacyPolicy />}
          />
        </Routes>
        {/* <IdleTimeoutModal
        showModal={showModal}
        setShowModal={setShowModal}
        remainingTime={remainingTime}
        handleStayLoggedIn={handleStayLoggedIn}
      /> */}
      </Suspense>
      <ToastContainer />
    </div>
  );
}

export default App;
